import * as React from "react";
import { Transition } from "react-transition-group";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import Typography from "@mui/joy/Typography";
import { Fade } from "@mui/material";
import Map from "../Map/Map";
import { useState } from "react";
import Loading from "../Loading/Loading";
import ChatBot from "./ProAIChatBot";

const ChatModal = ({ id }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <React.Fragment>
      <Button
        variant="outlined"
        size="sm"
        color="primary"
        aria-label=""
        sx={{ 
          fontWeight: 600, 
          maxHeight: "50px", 
          color: "white",
          borderColor: "white",
          '&:hover': {
            borderColor: "white"
          }
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        Realtor AI
      </Button>
      <Transition in={open} timeout={400}>
        {(state) => (
          <Modal
            keepMounted
            open={!["exited", "exiting"].includes(state)}
            onClose={() => setOpen(false)}
            slotProps={{
              backdrop: {
                sx: {
                  opacity: 0,
                  backdropFilter: "none",
                  transition: `opacity 400ms, backdrop-filter 400ms`,
                  ...{
                    entering: { opacity: 1, backdropFilter: "blur(8px)" },
                    entered: { opacity: 1, backdropFilter: "blur(8px)" },
                  }[state],
                },
              },
            }}
            sx={{
              visibility: state === "exited" ? "hidden" : "visible",
            }}
          >
            <ModalDialog
              aria-labelledby="fade-modal-dialog-title"
              aria-describedby="fade-modal-dialog-description"
              sx={{
                maxHeight: "85vh",
                overflow: "hidden",
                opacity: 0,
                transition: `opacity 300ms`,
                ...{
                  entering: { opacity: 1 },
                  entered: { opacity: 1 },
                }[state],
              }}
            >
              <div style={{ width: "800px", height: "1000px" }}>
                <ChatBot />
              </div>
            </ModalDialog>
          </Modal>
        )}
      </Transition>
    </React.Fragment>
  );
};

export default ChatModal;
